/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Summary_NoneInputs */

const en_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set`)
};

const fr_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non défini`)
};

const de_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht festgelegt`)
};

const it_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non impostato`)
};

const ru_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не задано`)
};

const es_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No está configurado`)
};

const zh_cn2_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未设置`)
};

const ja_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定されていません`)
};

const hi_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट नहीं`)
};

const pt_pt2_new_project_summary_none = /** @type {(inputs: New_Project_Summary_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não definido`)
};

/**
* | output |
* | --- |
* | "Not set" |
*
* @param {New_Project_Summary_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_summary_none = /** @type {((inputs?: New_Project_Summary_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Summary_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_summary_none(inputs)
	if (locale === "de") return de_new_project_summary_none(inputs)
	if (locale === "it") return it_new_project_summary_none(inputs)
	if (locale === "ru") return ru_new_project_summary_none(inputs)
	if (locale === "es") return es_new_project_summary_none(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_summary_none(inputs)
	if (locale === "ja") return ja_new_project_summary_none(inputs)
	if (locale === "hi") return hi_new_project_summary_none(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_summary_none(inputs)
	return en_new_project_summary_none(inputs)
});